module.exports = __webpack_public_path__ + "img/solution8.749f692c.png";